export default __webpack_public_path__ + "static/analytics-and-reporting-dad2ce9dbb3632332cd072272e1ac451.svg";